import { Injectable } from "@angular/core";
import { Api } from "../api/api";

import { ChatRoom } from "../../models/chat-room";

import { Observable } from "rxjs/Observable";
import { AlertController } from "ionic-angular";

export class ChatSearchParams {
  favorite_rank: number;
}

@Injectable()
export class ChatRoomProvider {
  url: string = "chat_rooms";

  constructor(public api: Api, public alertCtrl: AlertController) {}

  load(
    type: string,
    page: number,
    params: ChatSearchParams
  ): Observable<ChatRoom[]> {
    return this.api
      .get(this.url + "/" + type, false, { page: page, query: JSON.stringify(params) })
      .map((rooms) => rooms.map((room) => new ChatRoom(room)));
  }

  loadAll(
    type: string,
    page: number,
    params: ChatSearchParams
  ): Observable<ChatRoom[]> {
    params.favorite_rank = 0;
    return this.api
      .get(this.url + "/" + type, false, { page: page, query: JSON.stringify(params) })
      .map((rooms) => rooms.map((room) => new ChatRoom(room)));
  }

  search(type: string, query: string): Observable<ChatRoom[]> {
    return this.api
      .get(this.url + "/search", false, { q: query })
      .map((rooms) => rooms.map((room) => new ChatRoom(room)));
  }

  showOrCreateByUserId(
    userId: number,
    isPoint: boolean,
    likeFrom: string
  ): Observable<ChatRoom> {
    return this.api
      .post("users/" + userId.toString() + "/talks", {
        like_from: likeFrom,
      })
      .map((room) => new ChatRoom(room));
  }

  readAll(chatRoomId: number): Observable<any> {
    return this.api.post(this.url + "/" + chatRoomId + "/read_all", {});
  }

  favorite(chatRoomId: number, favoriteRank: number): Observable<any> {
    return this.api.post(this.url + "/" + chatRoomId + "/favorite", {
      favorite_rank: favoriteRank,
    });
  }

  deleteFavorite(chatRoomId: number): Observable<any> {
    return this.api.delete(this.url + "/" + chatRoomId + "/favorite");
  }

  hide(chatRoomId: number): Observable<any> {
    return this.api.post(this.url + "/" + chatRoomId + "/hide", {});
  }

  isFirstMessage(chatRoomId: number): Observable<any> {
    return this.api.post(this.url + "/" + chatRoomId + "/is_first_message", {});
  }

  setNote(chatRoomId: number, note: string): Observable<any> {
    return this.api.put(this.url + "/" + chatRoomId + "/note", {
      note: note,
    });
  }

  setAttachedName(chatRoomId: number, attachedName: string): Observable<any> {
    return this.api.put(this.url + "/" + chatRoomId + "/attach_name", {
      attached_name: attachedName,
    });
  }

  isShowedPointAlert(pointCallback: Function): void {
    let subtitle: string =
      "いいね、メッセージを送るためにはポイントが必要です。ポイントを購入しますか？";
    const alert = this.alertCtrl.create({
      title: "ポイントが足りません",
      subTitle: subtitle,
      buttons: [
        {
          text: "OK",
          handler: () => {
            pointCallback();
          },
        },
      ],
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/chat-room/chat-room.ts